import { Component } from '@angular/core';

@Component({
    selector: 'lib-no-operation',
    templateUrl: './no-operation.component.html',
    styleUrl: './no-operation.component.scss',
    standalone: false
})
export class NoOperationComponent {

}
